import React, { useContext } from 'react';

import classNames from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './FilterSubFooter.module.css';
import { FilSubContext } from '../FilterSub';

export const FilterSubFooter = ({}) => {
    const { activeSubs, setActiveSubs, setIsOpenList, setFilterTitle, setTotals } =
        useContext(FilSubContext);
    const guidList = activeSubs.map((sub) => sub.guid);

    const onReset = () => {
        setActiveSubs([
            {
                guid: 'all',
                title: i18next.t('FilterSubFooter.onReset.title'),
            },
        ]);
    };

    const onSubmit = () => {
        let done = 0;
        let receipt = 0;
        let paid = 0;
        let advancePayment = 0;
        let debt = 0;
        const $subs = $(document).find('.parent-block-top');
        $($subs).each(function () {
            const guid = $(this).attr('data-filter');

            if (!guidList.includes(guid)) {
                $(this).css({
                    overflow: 'hidden',
                    height: '0',
                    'margin-top': '0',
                });
            }
            if (guidList.includes('all') || guidList.includes(guid)) {
                done += Number($(this).find('[data-sub-done-value]').attr('data-sub-done-value'));
                receipt += Number(
                    $(this).find('[data-sub-receipt-value]').attr('data-sub-receipt-value')
                );
                paid += Number($(this).find('[data-sub-paid-value]').attr('data-sub-paid-value'));
                advancePayment += Number(
                    $(this)
                        .find('[data-sub-advancePayment-value]')
                        .attr('data-sub-advancePayment-value')
                );
                debt += Number($(this).find('[data-sub-debt-value]').attr('data-sub-debt-value'));

                $(this).css({
                    overflow: 'visible',
                    height: '100%',
                    'margin-top': '8px',
                });
            }
        });

        const updatedTotal = {
            done,
            receipt,
            paid,
            advancePayment,
            debt,
        };
        setTotals(updatedTotal);

        $(document).find('[data-done-value]').attr('data-done-value', done);
        $(document).find('[data-done-value]').text(numberFormatter.formatNumber(done));

        $(document).find('[data-receipt-value]').attr('data-receipt-value', receipt);
        $(document).find('[data-receipt-value]').text(numberFormatter.formatNumber(receipt));

        $(document).find('[data-paid-value]').attr('data-paid-value', paid);
        $(document).find('[data-paid-value]').text(numberFormatter.formatNumber(paid));

        $(document)
            .find('[data-advancePayment-value]')
            .attr('data-advancePayment-value', advancePayment);
        $(document)
            .find('[data-advancePayment-value]')
            .text(numberFormatter.formatNumber(advancePayment));

        $(document).find('[data-debt-value]').attr('data-debt-value', debt);

        $(document).find('[data-debt-value]').text(numberFormatter.formatNumber(debt));

        setIsOpenList(false);
        const getTitle = activeSubs.map((sub) => sub.title).join(', ');
        setFilterTitle(getTitle);
    };

    return (
        <div className={classNames(cls.listFooter)}>
            <UiButton
                onClick={onReset}
                btnColor="secondary"
                btnText={i18next.t('FilterSubFooter.return.onReset')}
            />

            <UiButton onClick={onSubmit} btnText={i18next.t('FilterSubFooter.return.onSubmit')} />
        </div>
    );
};
